import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';

import { MaterialModule } from '@app/material/material.module';
import { AlertModule } from '@shared/alert';
import { AssignToJobModule } from '@shared/assign-to-job/assign-to-job.module';
import { BatchOperationRejectCandidateModule } from '@shared/batch-operation-reject-candidate/batch-operation-reject-candidate.module';
import { BatchOperationSubmitHiringManagerReviewModule } from '@shared/batch-operation-submit-hiring-manager-review/batch-operation-submit-hiring-manager-review.module';
import { BatchOperationToolbarModule } from '@shared/batch-operation-toolbar/batch-operation-toolbar.module';
import { BatchOperationAdvanceRejectHiringManagerModule } from '@shared/batch-opetation-advance-reject-hiring-manager/batch-operation-advance-reject-hiring-manager.module';
import { CollectionModule } from '@shared/collection';
import { DropdownMenuWithIconsModule } from '@shared/dropdown-menu-with-icons/dropdown-menu-with-icons.module';
import { JobLocationModule } from '@shared/job-location/job-location.module';
import { LogoutWarningModalComponent } from '@shared/logout-warning-modal';
import { MultipleLocationInputModule } from '@shared/multiple-location/multiple-location-input.module';
import { NavLeftModule } from '@shared/nav-left/nav-left.module';
import { NoContentComponent } from '@shared/no-content/no-content.component';
import { PaginationModule } from '@shared/pagination';
import { TimerPipeModule } from '@shared/pipes/timer';
import { ReferralService } from '@shared/services/referral.service';
import { SideNavFilterModule } from '@shared/side-nav-filter/side-nav-filter.module';
import { SortSelectorModule } from '@shared/sort-selector/sort-selector.module';
import { ThumbModule } from '@shared/thumb/thumb.module';

import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { AtsButtonModule } from './ats-button/ats-button.module';
import { BestJobModule } from './best-job/best-job.module';
import { DefinitionListComponent } from './components';
import { CurrencyModule } from './currency/currency.module';
import { SharedDirectivesModule } from './directives';
import { FormModule } from './form/form.module';
import { HintModule } from './hint/hint.module';
import { ImageUploadModule } from './image-upload/image-upload.module';
import { ItemIndexEllipseModule } from './item-index-ellipse/item-index-ellipse.module';
import { LoaderModule } from './loader/loader.module';
import { LocationInputModule } from './location/location-input.module';
import { ModalModule } from './modal';
import { NavHeaderModule } from './nav-left-header/nav-header.module';
import { PageModule } from './page/page.module';
// Pipes
import { DaysPassedPipeModule, RemoveHtmlPipeModule, TruncatePipeModule } from './pipes/index';
import {
  ApiService,
  AssociationService,
  AttachmentService,
  CandidateAssociationService,
  CandidateService,
  EmailTemplatesService,
  FeedbackService,
  GeolocationService,
  JobMatchCandidatesService,
  RoleService,
  UserService,
} from './services';
import { ReferralBadgeComponent } from './referral-badge/referral-badge.component';
import { BatchOperationAddCandidatesToTalentPoolModule } from '@shared/batch-operation-add-candidates-to-talent-pool/batch-operation-add-candidates-to-talent-pool.module';
import { TalentPoolsService } from '@shared/services/talent-pools.service';
import { TeamMembersCardComponent } from '@modules/job-page/components/team-members-card/team-members-card.component';
import { UserItemModule } from '@shared/user-item/user-item.module';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { MojoPrivilegesModule } from 'mojo-privileges';
import { MojoCopiableTooltipModule } from 'mojo-copiable-tooltip';
import { ApplicationHistoryService } from '@shared/services/application-history.service';

export const sharedModules = [
  AlertModule,
  AssignToJobModule,
  AtsButtonModule,
  BestJobModule,
  CollectionModule,
  CommonModule,
  CurrencyModule,
  DaysPassedPipeModule,
  FormModule,
  FormsModule,
  HintModule,
  ImageUploadModule,
  ItemIndexEllipseModule,
  JobLocationModule,
  LoaderModule,
  LocationInputModule,
  MaterialModule,
  ModalModule,
  MultipleLocationInputModule,
  NavHeaderModule,
  NavLeftModule,
  NgSelectModule,
  PageModule,
  PaginationModule,
  ReactiveFormsModule,
  RemoveHtmlPipeModule,
  RouterModule,
  SharedDirectivesModule,
  SideNavFilterModule,
  SortSelectorModule,
  ThumbModule,
  TruncatePipeModule,
  BatchOperationAdvanceRejectHiringManagerModule,
  BatchOperationSubmitHiringManagerReviewModule,
  BatchOperationRejectCandidateModule,
  BatchOperationToolbarModule,
  BatchOperationAddCandidatesToTalentPoolModule,
  MojoFeatureExtensionsModule,
  MojoPrivilegesModule,
  DropdownMenuWithIconsModule,
];

export const sharedServices = [
  ApiService,
  AssociationService,
  AttachmentService,
  CandidateAssociationService,
  CandidateService,
  FeedbackService,
  GeolocationService,
  JobMatchCandidatesService,
  RoleService,
  UserService,
  ReferralService,
  EmailTemplatesService,
  TalentPoolsService,
  ApplicationHistoryService,
];

const components = [
  DefinitionListComponent,
  NoContentComponent,
  ReferralBadgeComponent,
  LogoutWarningModalComponent,
  TeamMembersCardComponent,
];

@NgModule({
  declarations: [...components],
  imports: [
    ...sharedModules,
    TimerPipeModule,
    RoundProgressModule,
    UserItemModule,
    MojoCopiableTooltipModule,
  ],
  exports: [...sharedModules, ...components],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [...sharedServices],
    };
  }
}
